import { Spacing } from '@persona-id/design-tokens';
import { ReactNode } from 'react';
import styled from 'styled-components';

const Container = styled.div.attrs(() => ({
  role: 'img',
  'aria-label': 'Pictograph of documents to upload',
}))<{ $backgroundColor?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: ${({ $backgroundColor, theme }) =>
    $backgroundColor ?? theme.iconColorHighlight};
  height: 160px;
  width: 100%;

  svg {
    margin: ${Spacing[2]};
  }
`;

const VerificationHeroBanner = ({
  children,
  backgroundColor,
  className,
}: {
  children: ReactNode;
  backgroundColor?: string;
  className?: string;
}) => {
  return (
    <Container
      className={className}
      $backgroundColor={backgroundColor}
      data-test='verification-hero-banner'
    >
      {children}
    </Container>
  );
};

export default VerificationHeroBanner;
